import { render, staticRenderFns } from "./comDialog.vue?vue&type=template&id=38422a86&scoped=true&"
import script from "./comDialog.vue?vue&type=script&lang=js&"
export * from "./comDialog.vue?vue&type=script&lang=js&"
import style0 from "./comDialog.vue?vue&type=style&index=0&id=38422a86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38422a86",
  null
  
)

export default component.exports